const BASE = 'https://encelad.onrender.com';

export interface Post {
  id: number;
  title: string;
  content: string;
  type: string;
  author: string;
  created_at: string;
}

export interface Comment {
  id: number;
  post_id: number | null;
  text: string;
  created_at: string;
}

export const login = async (password: string) => {
  const res = await fetch(`${BASE}/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ password }),
  });
  return res.json();
};

export const getPosts = async (
  page: number = 0,
  limit: number = 10,
  type?: string,
  search?: string
): Promise<Post[]> => {
  let url = `${BASE}/posts?offset=${page * limit}&limit=${limit}`;

  if (type) url += `&type=${type}`;
  if (search) url += `&search=${encodeURIComponent(search)}`;

  const res = await fetch(url);
  const json = await res.json();

  if (Array.isArray(json)) return json;
  if (Array.isArray(json.data)) return json.data;

  return [];
};

export const createPost = async (data: any) => {
  const res = await fetch(`${BASE}/posts`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });

  return res.json();
};

export const getPostComments = async (postId: number): Promise<Comment[]> => {
  const res = await fetch(`${BASE}/api/comments?post_id=${postId}`);
  const json = await res.json();

  if (Array.isArray(json)) return json;
  return [];
};

export const getGlobalComments = async (): Promise<Comment[]> => {
  const res = await fetch(`${BASE}/api/comments`);
  const json = await res.json();

  if (Array.isArray(json)) return json;
  return [];
};

export const getCommentsFeed = async (): Promise<Comment[]> => {
  const res = await fetch(`${BASE}/api/comments/feed`);
  const json = await res.json();

  if (Array.isArray(json)) return json;
  return [];
};

export const createComment = async (data: {
  post_id?: number | null;
  text: string;
}) => {
  const res = await fetch(`${BASE}/api/comments`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      post_id: data.post_id ?? null,
      text: data.text,
    }),
  });

  return res.json();
};

export const deleteComment = async (id: number, password: string) => {
  const res = await fetch(`${BASE}/api/comments/${id}`, {
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ password }),
  });

  return res.json();
};

export const deletePost = async (id: number, password: string) => {
  const res = await fetch(`${BASE}/posts/${id}`, {
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ password }),
  });

  return res.json();
};